import { render } from "./ActionArea.vue?vue&type=template&id=bb0d7c54"
import script from "./ActionArea.vue?vue&type=script&lang=js"
export * from "./ActionArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__